import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalLoaderService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  private isOverlaySubject = new BehaviorSubject<boolean>(false);
  public isLoading$ = this.isLoadingSubject.asObservable();
  public isOverlay$ = this.isOverlaySubject.asObservable();

  show(): void {
    this.isOverlaySubject.next(false);
    this.isLoadingSubject.next(true);
  }

  // keeps the page in place under a grey overlay instead of blanking it (as show() does for routing), so the
  // page and its keyboard focus survive, e.g. while a dashboard widget loads its dialog
  showOverlay(): void {
    this.isOverlaySubject.next(true);
    this.isLoadingSubject.next(true);
  }

  hide(): void {
    this.isLoadingSubject.next(false);
  }
}
